export default {"src":"/_next/static/media/twitter-round_svgrepo.com.ac0e1386.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};